<template>
    <div id="content">
        <div class="filters_content">
            <search-type></search-type>
            <search-title></search-title>
            <search-filter></search-filter>
        </div>
        <div class="col_results hidden-xs hidden-sm">
            <property-results></property-results>
        </div>
        <map-container></map-container>
    </div>
</template>

<script>
Vue.component('vue-pagination', require('./../pagination/pagination.vue').default);
import SearchType from './search-type.vue';
import SearchTitle from './search-title.vue';
import SearchFilter from './search-filter.vue';
import MapContainer from './map-container.vue';
import PropertyResults from './property-results.vue';

export default {
    props: {
        view: {
            type: String,
            required: true,
        },
		searchType: {
			type: String,
			required: true,
		},
		city: {
			type: Object,
			required: true,
		},
		state: {
			type: Object,
			required: true,
		},
		ads: {
			type: Array,
			required: true,
		},
		sponsoredAds: {
			type: Array,
			required: true,
            default: [],
		},
		district: {
			type: String,
			required: true,
		},
		pagination: {
			type: Object,
			required: true,
		},
		sort: {
			type: String,
			required: true,
		},
		filter: {
			type: Object|Array,
			required: true,
		},
		pageTitle: {
			type: String,
			required: true,
		},
	},
	components: { SearchType, SearchTitle, SearchFilter, MapContainer, PropertyResults },
    created() {
        this.$store.commit('setSearchType', this.searchType);
        this.$store.commit('setCity', this.city);
        this.$store.commit('setState', this.state);
        this.$store.commit('setAds', this.ads);
        this.$store.commit('setSponsoredAds', this.sponsoredAds);
        this.$store.commit('setPagination', this.pagination);
        this.$store.commit('setSort', this.sort);
        this.$store.commit('setFilter', this.filter);
        this.$store.commit('setPageTitle', this.pageTitle);
        this.$store.commit('setSelectedDistricts', this.district);

        if (this.ads.length >= this.pagination.per_page) {
            this.$store.commit('setButtonVisibility', true);
        }
    },
}
</script>

<style lang="scss">
.filters_content {
    width: 100%;
    padding: 0 15px;
    height: 190px;
    border-bottom: solid 1px #ececec;
    background-color: #fff;
    position: fixed;
    top: 60px;
    z-index: 5;
}
</style>